import React from 'react';
import ReactDOM from 'react-dom/client';
import { ContainerSonsMarins } from './components/ContainerSonsMarins';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContainerSonsMarins language={window.location.pathname.substring(0, 4) === "/en/" ? "en" : "fr"} />
  </React.StrictMode>
);